export interface ChangelogEntry {
    version: string;
    date: string;
    sections: { heading: string; items: string[] }[];
}

const VERSION_RE = /^##\s*\[?([^\]\s]+)\]?\s*[–-]\s*(.+?)\s*$/;
const SECTION_RE = /^###\s+(.+?)\s*$/;
const ITEM_RE = /^[-*]\s+(.+?)\s*$/;

export function parseChangelog(markdown: string): ChangelogEntry[] {
    const entries: ChangelogEntry[] = [];
    let current: ChangelogEntry | null = null;
    let section: { heading: string; items: string[] } | null = null;

    for (const rawLine of markdown.split(/\r?\n/)) {
        const line = rawLine.trim();
        const versionMatch = line.match(VERSION_RE);
        if (versionMatch) {
            current = { version: versionMatch[1], date: versionMatch[2], sections: [] };
            entries.push(current);
            section = null;
            continue;
        }
        if (!current) continue;

        const sectionMatch = line.match(SECTION_RE);
        if (sectionMatch) {
            section = { heading: sectionMatch[1], items: [] };
            current.sections.push(section);
            continue;
        }

        const itemMatch = line.match(ITEM_RE);
        if (itemMatch && section) {
            section.items.push(itemMatch[1]);
        }
    }

    return entries;
}
